// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    parseBlendingRanges: function() {
      var i, j, length, numChannels, ref, results;
      length = this.file.readInt();
      if (length === 0) {
        return;
      }
      this.blendingRanges.grey = {
        source: {
          black: [this.file.readByte(), this.file.readByte()],
          white: [this.file.readByte(), this.file.readByte()]
        },
        dest: {
          black: [this.file.readByte(), this.file.readByte()],
          white: [this.file.readByte(), this.file.readByte()]
        }
      };
      numChannels = (length - 8) / 8;
      this.blendingRanges.channels = [];
      results = [];
      for (i = j = 0, ref = numChannels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        results.push(this.blendingRanges.channels.push({
          source: {
            black: [this.file.readByte(), this.file.readByte()],
            white: [this.file.readByte(), this.file.readByte()]
          },
          dest: {
            black: [this.file.readByte(), this.file.readByte()],
            white: [this.file.readByte(), this.file.readByte()]
          }
        }));
      }
      return results;
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer/blending_ranges.js
// module id = 52
// module chunks = 0